import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { getCurrentHub, addGlobalEventProcessor } from '@sentry/core';
import { isInstanceOf } from '@sentry/utils';
import { exceptionFromError } from '../eventbuilder.js';
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */

var LinkedErrors = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  function LinkedErrors() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LinkedErrors);

    LinkedErrors.prototype.__init.call(this);

    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }
  /**
   * @inheritDoc
   */


  _createClass(LinkedErrors, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = LinkedErrors.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce() {
      var client = getCurrentHub().getClient();

      if (!client) {
        return;
      }

      addGlobalEventProcessor(function (event, hint) {
        var self = getCurrentHub().getIntegration(LinkedErrors);
        return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
      });
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'LinkedErrors';
    }
  }]);

  return LinkedErrors;
}();

LinkedErrors.__initStatic();
/**
 * @inheritDoc
 */


function _handler(parser, key, limit, event, hint) {
  if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
    return event;
  }

  var linkedErrors = _walkErrorTree(parser, limit, hint.originalException, key);

  event.exception.values = [].concat(_toConsumableArray(linkedErrors), _toConsumableArray(event.exception.values));
  return event;
}
/**
 * JSDOC
 */


function _walkErrorTree(parser, limit, error, key) {
  var stack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (!isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }

  var exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception].concat(_toConsumableArray(stack)));
}

export { LinkedErrors, _handler, _walkErrorTree };